export default __webpack_public_path__ + "static/media/Cert.f7b08ef5.jpg";